import React, { useEffect, useState } from 'react';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import Board from './Board';

const CURRENT_YEAR = new Date().getFullYear();

export default function Dashboard() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.role === 'staff';
  const [subjectProgress, setSubjectProgress] = useState(null);

  useEffect(() => {
    if (isAdmin) {
      api.get('/admin/dashboard/subject-progress', { params: { year: CURRENT_YEAR } }).then((res) => setSubjectProgress(res.data));
    }
  }, [isAdmin]);

  return (
    <div className="page">
      {isAdmin && (
        <div className="card">
          <h3>학년별 과목 진도율</h3>
          <p className="panel-meta">과목별 국토부 지정 총 법정시수 대비, 해당 학년에서 교수계획서로 진행된 시수의 비율입니다.</p>
          <div className="progress-grade-grid">
            {['1', '2', '3'].map((grade) => {
              const gradeData = subjectProgress?.[grade];
              const rows = gradeData?.rows ?? [];
              return (
                <div key={grade} className="progress-grade-block">
                  <h4>
                    {grade}학년
                    {gradeData && <span className="progress-grade-count"> ({gradeData.student_count}명)</span>}
                  </h4>
                  {rows.map((row) => (
                    <div key={row.subject} className="progress-row">
                      <div className="progress-row-label">{row.subject}</div>
                      <div className="progress-bar-track">
                        <div className="progress-bar-fill" style={{ width: `${Math.min(row.percent, 100)}%` }} />
                      </div>
                      <div className="progress-row-percent">{row.percent}%</div>
                    </div>
                  ))}
                  {!subjectProgress && <div className="progress-row-loading">불러오는 중...</div>}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <Board />
    </div>
  );
}
